// extracted by mini-css-extract-plugin
export default {"inputSearch":"input-search_inputSearch__-yKpO","toggle":"input-search_toggle__7AsF+","rotate":"input-search_rotate__X8z5G"};